import React from "react";
import { FormControl, MenuItem, Pagination, Select, Stack, Typography } from "@mui/material";
import { useCurrentTheme } from "../../../../../../../theme/theme";
import { ThemeColors } from "../../../../../../../theme/themeValues";

type Props = {
	page: number;
	pages: number;
	pageSize: number;
	itemsCount: number;
	pageSizes: number[];
	onPageChange: (newPage: number) => void;
	onPageSizeChange: (newPageSize: number) => void;
};

export default function CustomPagination({
	page,
	pages,
	pageSize,
	itemsCount,
	pageSizes,
	onPageChange,
	onPageSizeChange,
}: Props) {
	const { theme } = useCurrentTheme();

	return (
		<Stack
			direction="row"
			justifyContent="flex-end"
			alignItems="center"
			py={2}
			px={1}
			spacing={4}
			sx={{
				borderTop: "1px solid rgba(0,0,0,0.1)",
				bgcolor: "background.paper",
			}}
		>
			{/* Rows per page */}
			<FormControl size="small">
				<Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2}>
					<Typography variant="body2" color="text.primary">
						Rows per page:
					</Typography>

					<Select
						variant="standard"
						disableUnderline
						value={pageSize}
						onChange={(e) => onPageSizeChange(Number(e.target.value))}
						sx={{
							color: ThemeColors.LightPrimary,
							"& fieldset": {
								border: "none",
							},
							"& .MuiSelect-select": {
								padding: 0,
								fontSize: "0.875rem",
								fontWeight: 700,
								color: theme.palette.primary.main,
							},
						}}
					>
						{pageSizes.map((size) => (
							<MenuItem key={size} value={size}>
								{size}
							</MenuItem>
						))}
					</Select>
				</Stack>
			</FormControl>

			{/* Page info */}
			<Typography variant="body2" color="text.primary">
				Page <strong>{page + 1}</strong> of <strong>{pages}</strong>— Total <strong>{itemsCount}</strong> items
			</Typography>

			{/* Pagination */}

			<Pagination
				count={pages}
				page={page + 1}
				onChange={(_, value) => onPageChange(value - 1)}
				color="primary"
				shape="rounded"
			/>
		</Stack>
	);
}
